// extracted by mini-css-extract-plugin
module.exports = {"SectionA7":"SectionA7_SectionA7__7zzPl"};